import styled from 'styled-components';

export const WalletMainWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding-bottom: ${props.theme.spacing.large.l30};
    position:relative;
    @media(max-width:1023px){
      flex-direction: column;
    }
  `,
);

export const WalletTopBack = styled.div(
  props => `
      width:100%;
      display: flex;
      height: 20rem;
      // background-color: ${props.theme.colors.blue.lightef};
      background-image:  linear-gradient(to bottom, #0b1b29 -60%, #554176 100%);
      position: absolute;
      top: 0;
      left:0;
      @media(max-width:1023px){
        display: none;
      }
  `,
);

export const WalletOuterWrap = styled.div(
  props => `
    max-width: 120rem;
    width:100%;
    display: flex;
    margin:0 auto;
    justify-content: space-between;
    padding-top: ${props.theme.spacing.large.l30};
    z-index: 3;
    @media (max-width: 768px) {
      width:100%;
      flex-direction: column;
      margin:0px;
      flex-direction: column;
      padding-top: ${props.theme.spacing.large.l20};
    }
  `,
);

export const WalletInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
  `,
);

export const RechargeStatusWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 0 1rem 0;
    animation: fadeOut 5s forwards;
    @keyframes fadeOut {
      0%   {visibily: 1;}
      90%  {opacity: 1;}
      100% {opacity: 0;}
    }
  `,
);
export const RechargeStatus = styled.div(
  props => `
    margin: auto;
    display: flex;
    outline: none;
    border: none;
    cursor: pointer;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l60};
    border-radius: 3.4rem;
    box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
    background-image: ${
      props.success
        ? 'linear-gradient(84deg, #43e1a8, #219393)'
        : 'linear-gradient(255deg, #ff3e5e -56%, #ff7f3f 78%)'
    };
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const BlackListPopupOverlay = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height:100%;
    background-color: rgba(0,0,0,0.5);
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom: 0;
    z-index:9;
  `,
);

export const BlacklistPopupWrap = styled.div(
  props => `
    width:500px;
    height: 150px;
    border-radius: 8px;
    background-color: ${props.theme.colors.white.base};
    padding: ${props.theme.spacing.large.l15}
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    display: flex;
  `,
);

export const BlackListInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font16};
    color: ${props.theme.colors.black.base};
    line-height: 1.3;
  `,
);

export const BlackListHomeBtn = styled.button(
  props => `
    display: flex;
    outline: none;
    border: none;
    cursor: pointer;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l60};
    border-radius: 3.4rem;
    box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(93deg, #53b2fe 0%, #065af3 130%);
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    text-transform: uppercase;
  `,
);

export const NeftDetailInfoPop = styled.div(
  props => `
    width:100%;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 9;
  `,
);

export const NeftDetailPopCloseBtn = styled.div(
  props => `
    position: absolute;
    top:-2rem;
    right:-4rem;
    background-color: ${props.theme.colors.white.base};
    border-radius: 50%;
    width:2.4rem;
    height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 768px) {
      top: -4rem;
      right: 50%;
      transform: translateX(50%);
    }
  `,
);

export const NeftDetailsInfoPopWrap = styled.div(
  props => `
    width:48rem;
    height: 48rem;
    background-color: ${props.theme.colors.white.base};
    border-radius: 0.8rem;
    position: relative;
    @media (max-width: 768px) {
      max-width: 90%;
      margin:0 auto;
    }
  `,
);

export const ErrorText = styled.p(
  props => `
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${props.theme.font.large.font24};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
    height:100%;
    margin: 0 auto;
    text-align: center;
  `,
);

export const NeftDetailMainWrapper = styled.div(
  props => `
    width:100%;
    display: flex;
    overflow: auto;
    max-height: -webkit-fill-available;
    flex-direction: column;
  `,
);

export const NeftDetailHeadWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l30};
    border-bottom: 1px solid rgba(0,0,0,0.2);
    @media (max-width: 768px) {
      padding: ${props.theme.spacing.large.l20};
    }
  `,
);

export const NeftDetailsHeadText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font20};
    font-weight: ${props.theme.font.fontWeight.black};
    color: #141823
  `,
);

export const NeftDetailInfoInnerWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l15} ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l30};
    @media (max-width: 768px) {
      padding: ${props.theme.spacing.large.l20};
    }
  `,
);

export const NeftDetailInfoText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
  `,
);

export const NeftDetailsInfoSubText = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    padding-top: ${props.theme.spacing.large.l15};
  `,
);

export const NeftAccountDetailsWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    padding: ${props.theme.spacing.large.l30};
    @media (max-width: 768px) {
      padding: ${props.theme.spacing.large.l20};
    }
  `,
);

export const NeftAccountDetailInnerWrap = styled.div(
  props => `
    display: flex;
    align-items: center;
    padding-bottom: ${props.theme.spacing.base};
  `,
);

export const NeftAccountDetailTypeText = styled.p(
  props => `
    width:40%;
    display: flex;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
  `,
);

export const NeftAccountDetailInfoText = styled.p(
  props => `
    width:60%;
    display: flex;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `,
);

export const Cont = styled.div`
  width: 1200px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    margin: 0px;
  }
`;

export const Left = styled.div`
  width: 380px;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Right = styled.div`
  width: 800px;
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
